<template>
  <div class="pa-4 pb-2 text-caption text-textDark text-uppercase">
    Job post preview
  </div>

  <div class="wizard-job-preview d-flex flex-column ga-4 pa-4">
    <div
      v-if="loading"
      class="d-flex justify-center align-center h-100"
    >
      <v-progress-circular
        indeterminate
        color="brandPrimary"
        size="48"
        width="3"
      />
    </div>

    <template v-else-if="fields">
      <div class="d-flex flex-column ga-1">
        <h2 class="text-h2 text-textDarkest text-center">
          {{ title }}
        </h2>

        <div
          v-if="location"
          class="text-body-2 text-textLight text-center"
        >
          {{ location }}
        </div>

        <div
          v-if="jobCode"
          class="text-body-3 text-textLight text-center"
        >
          {{ jobCode }}
        </div>
      </div>

      <div
        v-for="field in nonEmptyFields"
        :key="field.type || field.id"
        class="wizard-preview-field"
      >
        <p
          v-if="field.label"
          class="mb-2 text-body-1 text-textDark"
        >
          {{ field.label }}
        </p>
        <DocumentPreviewFieldHtml :html="field.html" />
      </div>
    </template>

    <div
      v-else
      class="d-flex align-center justify-center h-100 text-body-2 text-textLight text-center pa-6"
    >
      <slot name="empty">
        Select a result to preview its content here.
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DocumentPreviewFieldHtml from '@ui/components/general/DocumentPreviewFieldHtml/DocumentPreviewFieldHtml.vue';
import { joinFooterAndHeaderFields } from '@/helpers/headerFooterFields';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  location: {
    type: String,
    default: '',
  },
  jobCode: {
    type: String,
    default: '',
  },
  // Fields composed by the backend; null means there is nothing to preview yet.
  fields: {
    type: Array,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const nonEmptyFields = computed(() => {
  if (!props.fields) return [];
  return joinFooterAndHeaderFields(props.fields)
    .filter((field) => field.html?.trim?.().length > 20);
});
</script>
